module.exports = __webpack_public_path__ + "fonts/font.0cc9176.woff";